const STELLATE_URLS = {
  qaa: 'https://qaa.priceline.com/graphcdn',
  qab: 'https://qab.priceline.com/graphcdn',
  preprod: 'https://preprod.priceline.com/graphcdn',
  prod: 'https://www.priceline.com/graphcdn',
}

export { STELLATE_URLS }
